/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Desc_Set_IncodeInputs */



/**
* | output |
* | --- |
* | "Update the incode of the selected Event based on the current media time" |
*
* @param {Shortcut_Keys_Desc_Set_IncodeInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_desc_set_incode = /** @type {((inputs?: Shortcut_Keys_Desc_Set_IncodeInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Desc_Set_IncodeInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Mettre a jour l'incode de l'evenement selectionne selon le temps media actuel")
	if (locale === "de") return /** @type {LocalizedString} */ ("Aktualisiere den Incode des ausgewählten Ereignisses basierend auf der aktuellen Medienzeit.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Aggiorna l'INCODE dell'evento selezionato in base all'ora corrente del supporto")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Обновите входящий код выбранного события в соответствии с текущим временем воспроизведения медиафайла.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Actualizar la codificación del evento seleccionado en función del tiempo del medio actual")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("根据当前媒体时间更新所选事件的编码")
	if (locale === "ja") return /** @type {LocalizedString} */ ("現在のメディア時間に基づいて、選択したイベントのインコードを更新します。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("वर्तमान मीडिया समय के आधार पर चयनित इवेंट के इनकोड को अपडेट करें।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Atualize o código de entrada do evento selecionado com base no horário atual da mídia.")
	return /** @type {LocalizedString} */ ("Update the incode of the selected Event based on the current media time")
});